// GenericCrudPage.tsx
import React from 'react';
import { GenericCrudCard } from '../components/GenericCrudCard/GenericCrudCard';

interface CrudItem {
	id: number;
	label?: string;
	name?: string;
}

type FetchResult<T> =
	| T[]
	| {
			data: T[];
			meta: { page: number; limit: number; total: number; pages: number };
	  };

interface CrudPageProps<T extends CrudItem> {
	queryKey: string;
	title: string;
	fetchData: (
		token: string,
		options?: {
			page?: number;
			limit?: number;
			sort?: string;
			order?: 'ASC' | 'DESC';
			filters?: Record<string, string>;
		}
	) => Promise<FetchResult<T>>;
	deleteItem: (id: number, token: string) => Promise<void>;
	tableColumns: { label: string; render: (item: T) => React.ReactNode }[];
	addButtonLabel?: string;
	getEditPath?: (id: number) => string;
	getManagePath?: (id: number) => string;
	getManageQuoteVersionPath?: (id: number) => string;
	getAddPath: () => string;
	getReturnPath: () => string;
	emptyMessage?: string;
}

export function GenericCrudPage<T extends CrudItem>({
	queryKey,
	title,
	fetchData,
	deleteItem,
	tableColumns,
	addButtonLabel = 'Ajouter',
	getEditPath,
	getAddPath,
	getManagePath,
	getManageQuoteVersionPath,
	getReturnPath,
	emptyMessage,
}: CrudPageProps<T>) {
	return (
		<div className="min-h-screen bg-gray-100 p-6">
			<GenericCrudCard<T>
				queryKey={queryKey}
				title={title}
				fetchData={fetchData}
				deleteItem={deleteItem}
				tableColumns={tableColumns}
				addButtonLabel={addButtonLabel}
				getEditPath={getEditPath}
				getAddPath={getAddPath}
				getManagePath={getManagePath}
				getManageQuoteVersionPath={getManageQuoteVersionPath}
				getReturnPath={getReturnPath}
				emptyMessage={emptyMessage}
				size="lg"
			/>
		</div>
	);
}

export default GenericCrudPage;
